import React, { useState } from 'react';
import UnifiedGallery from '../components/UnifiedGallery';
import useStandardGallery from '../hooks/useStandardGallery';

const PanePage = () => {
  const [showMore, setShowMore] = useState(false);
  
  // Use standardized gallery hook with consistent configuration
  const { getGalleryProps } = useStandardGallery('pane');

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-bread-slice"></i>
          Pane
        </h1>
        <p>The foundation of many meals around the world - Bread! From crusty baguettes to soft sandwich loaves, from traditional sourdough to artisanal focaccia.</p>
      </div>
      
      <div className="page-content">
        <div className="section">
          <p>
            The foundation of many meals around the world - <b>Bread!</b> From crusty baguettes to soft sandwich loaves, from traditional sourdough to artisanal focaccia, bread has been nourishing humanity for thousands of years.
            Each culture has its own unique take on this essential staple food.
          </p>
          {showMore && (
            <div className="extended-intro">
              <p>Did you know that bread is the main ingredient in the most famous Italian meal there is! Pizza is amazing and in order to make pizza, you need dough, just like bread.</p>
            </div>
          )}

          <div className="cta-buttons">
            <button className="cta-btn primary" onClick={handleCelebration}>
              <i className="fas fa-pizza-slice"></i>
              {showMore ? 'Less' : 'More About Food'}
            </button>

            {/* Pane Gallery */}
            <div className="futbol-gallery-section">
              <UnifiedGallery 
                {...getGalleryProps("What's to eat?  Breakfast, Snacks, Lunch, Appetizers, Dinner, & Dessert.")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanePage;
